// ─── Social sharing utilities ─────────────────────────────────────────────────
// Domain-agnostic share-URL builders — usable on blogs, case studies, news,
// landing pages, or any content that needs social-share links.
// Static crawlable <a> hrefs are lighter and SEO-friendlier than JS-only share
// buttons, which is why these return plain URL strings rather than opening
// pop-ups directly.

export const shareLinks = {
    twitter: (url: string) => `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`,
    linkedin: (url: string) => `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
    facebook: (url: string) => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`
};
